import { FC, JSXElementConstructor, ReactElement } from "react";
import { IconButton, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

interface ITooltipInfoProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  title: ReactElement<any, string | JSXElementConstructor<any>>;
}

const TooltipInfo: FC<ITooltipInfoProps> = ({ title }) => (
  <Tooltip title={title} placement="top" arrow>
    <IconButton size="small" sx={{ ":hover": { backgroundColor: "unset" } }}>
      <InfoIcon />
    </IconButton>
  </Tooltip>
);

export default TooltipInfo;
